import React from 'react';
import Container from 'container';
import TitleSubtitleHeadline from 'headlines/simple-title-subtitle';
import CardD from 'cards/card-d';
import s from './3cardsrow.module.scss';

export default function ThreeCardsRowSection({
  title,
  subtitle,
  cards,
  ...props
}) {
  return (
    <Container className={s.root}>
      <TitleSubtitleHeadline {...{ title, subtitle }} />
      <div className={s.cards}>
        {cards.map(el => (
          <CardD key={el.title} className={s.card} {...el} />
        ))}
      </div>
    </Container>
  );
}
